// src/contexts/ElementDeleteContext.js
import React, { createContext, useContext, useState } from 'react';
import axios from 'axios';
import { useUserContext } from './UserContext';

const ElementDeleteContext = createContext();

const baseUrl = process.env.REACT_APP_API_URL;
const endpointDelete = `${baseUrl}/delete-elements`;


export const ElementDeleteProvider = ({ children }) => {
  const { tokens } = useUserContext();
  const [isDeleting, setIsDeleting] = useState(false);
  const [deleteError, setDeleteError] = useState(null);
  const [deleteSuccess, setDeleteSuccess] = useState(false);

  const deleteElements = async (items) => {
    setIsDeleting(true);
    setDeleteError(null);
    setDeleteSuccess(false);

    try {
      const token = tokens?.accessToken;
      if (!token) throw new Error("Token manquant pour l'authentification.");

      const response = await axios.post(
        endpointDelete,
        { items },
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );

      const result = response.data;
      console.log('[ElementDeleteContext] Suppression réussie :', result);
      setDeleteSuccess(true);
      return result;
    } catch (err) {
      console.error('[ElementDeleteContext] Erreur de suppression :', err);
      setDeleteError(err.message || 'Erreur inconnue');
      throw err;
    } finally {
      setIsDeleting(false);
    }
  };

  return (
    <ElementDeleteContext.Provider value={{
      deleteElements,
      isDeleting,
      deleteError,
      deleteSuccess
    }}>
      {children}
    </ElementDeleteContext.Provider>
  );
};

export const useElementDeleteContext = () => useContext(ElementDeleteContext);
